export enum FeatureToggleIdentifier {
  SHOW_PLAYGROUND = "SHOW_PLAYGROUND",
  ENABLE_INTERNATIONAL_PHONE_NUMBER = "ENABLE_INTERNATIONAL_PHONE_NUMBER",
  ENABLE_AUTH_IDENTIFICATION_TYPE_SELECTION = "ENABLE_AUTH_IDENTIFICATION_TYPE_SELECTION",
  ENABLE_INTERCARE_MEDICAL_ASSISTANCE = "ENABLE_INTERCARE_MEDICAL_ASSISTANCE",
  ENABLE_INTERNATIONAL_PHONE_NUMBER_UG = "ENABLE_INTERNATIONAL_PHONE_NUMBER_UG",
  ENABLE_FACE_SCAN_PRODUCT_RULES = "ENABLE_FACE_SCAN_PRODUCT_RULES",
  ENABLE_CHAT_BOT = "ENABLE_CHAT_BOT",
  ENABLE_COLLECT_LEAD_SOURCE_STORE_SELECTION = "ENABLE_COLLECT_LEAD_SOURCE_STORE_SELECTION",
  ENABLE_THIRD_PARTY_AUTHENTICATION = "ENABLE_THIRD_PARTY_AUTHENTICATION",
  ENABLE_PATHOLOGY_PANELS = "ENABLE_PATHOLOGY_PANELS",
  ENABLE_MAINTENANCE_MODE = "ENABLE_MAINTENANCE_MODE",
  ENABLE_PROMO_CODES = "ENABLE_PROMO_CODES",
  ENABLE_DEPENDANT_SERVICE_OFFERING = "ENABLE_DEPENDANT_SERVICE_OFFERING",
  ENABLE_FORCE_APP_UPDATE = "ENABLE_FORCE_APP_UPDATE",
  ENABLE_VOUCHER_REDEMPTION = "ENABLE_VOUCHER_REDEMPTION",
  ENABLE_DOC_MED_BUNDLES = "ENABLE_DOC_MED_BUNDLES",
  ENABLE_ENHANCED_PAYMENT_OPTIONS = "ENABLE_ENHANCED_PAYMENT_OPTIONS",
  ENABLE_ONE_VOUCHER_REDEMPTION = "ENABLE_ONE_VOUCHER_REDEMPTION",
  ENABLE_CONSULTATION_PAYMENT_HISTORY = "ENABLE_CONSULTATION_PAYMENT_HISTORY",
  ENABLE_DISCOUNT_VOUCHERS = "ENABLE_DISCOUNT_VOUCHERS",
  ENABLE_UNIFIED_CARE = "ENABLE_UNIFIED_CARE",
  ENABLE_SINGLE_CONSULTATION_ID = "ENABLE_SINGLE_CONSULTATION_ID",
  ENABLE_DEBUG_CONSOLE_LOGS = "ENABLE_DEBUG_CONSOLE_LOGS",
  ENABLE_TRENDED_VITALS = "ENABLE_TRENDED_VITALS",
  ENABLE_API_MAINTENANCE_MODE = "ENABLE_API_MAINTENANCE_MODE",
}

const featureToggles = mapIdentifierKeysToEnvironmentVariables();

function getFeatureToggleDataStore(): any {
  if (typeof window.Cypress !== "undefined") {
    try {
      return JSON.parse(
        window.localStorage.getItem("__cypress.featureToggles") || "{}"
      );
    } catch (error) {
      return { error };
    }
  } else {
    return featureToggles;
  }
}

function mapIdentifierKeysToEnvironmentVariables() {
  return Object.values(FeatureToggleIdentifier)
    .map((featureIdentifier) => {
      return {
        key: featureIdentifier,
        value:
          import.meta.env[`VITE_APP_FEATURE_${featureIdentifier}`] === "true"
            ? true
            : false,
      };
    })
    .reduce((accumulator: any, currentValue: any) => {
      accumulator[currentValue.key] = currentValue.value;
      return accumulator;
    }, {});
}

export function isFeatureEnabled(
  featureIdentifier: FeatureToggleIdentifier | string
): boolean {
  return getFeatureToggleDataStore()[featureIdentifier];
}
